// extracted by mini-css-extract-plugin
export var center = "_13-2";
export var clickableRow = "_13-5";
export var expandedRow = "_13-7";
export var hoverable = "_13-4";
export var left = "_13-1";
export var right = "_13-3";
export var row = "_13-0";
export var selectedRow = "_13-6";
export var summaryRow = "_13-8";